import React from 'react'
import ErrorScreen from '../ErrorScreen'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.group('🚨 Error Screen - Application Error')
    console.log({
      message: error?.message,
      stack: error?.stack,
      name: error?.name,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href,
      referrer: document.referrer,
      language: navigator.language,
      platform: navigator.platform,
      cookieEnabled: navigator.cookieEnabled,
      onLine: navigator.onLine,
      screenResolution: `${screen.width}x${screen.height}`,
      viewportSize: `${window.innerWidth}x${window.innerHeight}`,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      memoryInfo: performance.memory
        ? {
            usedJSHeapSize: performance.memory.usedJSHeapSize,
            totalJSHeapSize: performance.memory.totalJSHeapSize,
            jsHeapSizeLimit: performance.memory.jsHeapSizeLimit,
          }
        : 'Not available',
      performanceTiming: performance.timing
        ? {
            navigationStart: performance.timing.navigationStart,
            loadEventEnd: performance.timing.loadEventEnd,
            domContentLoadedEventEnd:
              performance.timing.domContentLoadedEventEnd,
          }
        : 'Not available',
      localStorage: {
        available: typeof Storage !== 'undefined',
        keys: Object.keys(localStorage || {}),
      },
      sessionStorage: {
        available: typeof Storage !== 'undefined',
        keys: Object.keys(sessionStorage || {}),
      },
      cookies: document.cookie ? document.cookie.split(';').length : 0,
      errorBoundaryInfo: {
        componentStack: error?.componentStack,
        errorInfo: error?.errorInfo,
      },
    })
    console.groupEnd()
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErrorScreen />
    }

    return this.props.children
  }
}

export default ErrorBoundary
